const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInDowjonesStar',
    accessToken: 'accessTokenDowjonesStar',
    userRole: 'userRole'
  }
}

export default AppConfig;
